var exports = {
  "p_": "list__Ufo_P8",
  "Nr": "card__bh_bUp",
  "rx": "cardTitleOnly__1LIEnS",
  "DD": "title__-P2RsI",
  "yu": "metadata___bd9ob",
};

module.exports = exports;
